import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { publicRoutes, authProtectedRoutes } from "./Routes";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUserId, setUserRole, setUserName, setJwtToken, setU_photo, setPermissions, setIsSuperAdmin, setIsCreatedByAdmin } from './Store/Role/action';
import fetchData from "./components/authenticate";
import { useEffect, useRef } from "react";
import './index.css';

function RoutesHandler() {
  const location = useLocation();
  const sessionToken = sessionStorage.getItem("sessionToken");
  const userId = useSelector((state) => state.roleReducer.userId);
  const userPermissions = useSelector((state) => state.roleReducer.permissions);
  const superAdmin = useSelector((state) => state.roleReducer.isSuperAdmin);
  const isCreatedByAdmin = useSelector((state) => state.roleReducer.isCreatedByAdmin);
  const dispatch = useDispatch();
  // Guards against the alert()+redirect firing more than once: this effect
  // re-runs on every location.pathname change (including internal redirects
  // like <Navigate> while unauthenticated), but `window.location = "/login"`
  // doesn't unload the page instantly — so without this guard, each extra
  // pathname change before the browser actually navigates away fired another
  // stacked alert(), which is why "OK" had to be clicked multiple times.
  const redirectingToLogin = useRef(false);

  useEffect(() => {
    const unauthenticatedPaths = ["/login", "/reset-password"];
    if (!unauthenticatedPaths.includes(location.pathname)) {
      const authenticateUser = async () => {
        if (redirectingToLogin.current) return;
        try {
          const response = await fetchData();
          if (response) {
            console.log("User is authenticated");
            dispatch(setUserId(response.data.data.id));
            dispatch(setUserRole(response.data.data.role_id));
            dispatch(setUserName(response.data.data.name));
            dispatch(setPermissions(response.data.data.permissions));
            dispatch(setIsSuperAdmin(response.data.data.superAdmin));
            dispatch(setIsCreatedByAdmin(response.data.data.isCreatedByAdmin || false));
          } else {
            redirectingToLogin.current = true;
            alert("User is not authenticated");
            window.location = "/login";
          }
        } catch (error) {
          console.error("Error during authentication:", error);
          redirectingToLogin.current = true;
          window.location = "/login"; // Redirect to login in case of error
        }
      };

      authenticateUser();
    }
  }, [location.pathname, dispatch]);

  const hasAccess = (route) => {
    if (superAdmin) return true;
    if (isCreatedByAdmin) {
      // Admin-created users can only access Create Feed (id: 30)
      return route.id === 30;
    }
    return userId && userPermissions && userPermissions.includes(route.id.toString());
  };

  return (
    <Routes>
      {publicRoutes.map((route, idx) => (
        <Route key={idx} path={route.path} element={<route.component />} />
      ))}

      {authProtectedRoutes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={
            hasAccess(route) ? (
              <route.component />
            ) : (
              <Navigate to={isCreatedByAdmin ? "/feeds/create" : "/access-denied"} />
            )
          }
        />
      ))}
    </Routes>
  );
}
function App() {
  return (
    <Router>
      <RoutesHandler />
    </Router>
  );
}

export default App;
